// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","selected":"selected_WcHGP","UseButton":"UseButton_eg5nF"};